<template>
  <div class="row dashboard_container" aria-label="Student Dashboard Page Content" v-if="showComponent">
    <div class="col-12">

      <v-tour name="myTour" :steps="steps" :options="tourOptions" class="app_pg_tour">
        <template slot-scope="tour">
          <transition name="fade">
            <v-step
              v-if="tour.currentStep === index"
              v-for="(step, index) of tour.steps"
              :key="index"
              :step="step"
              :previous-step="tour.previousStep"
              :next-step="tour.nextStep"
              :stop="tour.stop"
              :is-first="tour.isFirst"
              :is-last="tour.isLast"
              :labels="tour.labels"
              >
              <template>
                <div slot="actions" class="actions">
                  <button class="btn_close" @click="tour.stop" title="End Tour">
                  <span class="ic-close"></span>
                  </button>
                  <div class="hide_tour_check">
                    <input type="checkbox" v-model="isDoNotOpenGuide" id="hideApplicationTour">
                    <label for="hideApplicationTour">Don't show me this again</label>
                  </div>
                </div>
              </template>
            </v-step>
          </transition>
        </template>
      </v-tour>
      <div class="tfa-dashboard-section">
        <div class="top-section row">
          <div class="dashboard-row stream-section col-xl-9 col-lg-12 col-md-12 col-sm-12">
            <div class="">
              <div class="card ace_sec" :aria-label="username + '  Progress and Performance Summary'">
                <div class="card-header">
                  <span class="icon icon-stream"></span>
                  <h4 class="label" role="heading" aria-level="2">Welcome {{username}}</h4>
                  <div class="legend-popup">
                    <div class="btn_legends" aria-label="progress legend">
                      <div class="legends_container">
                        <b-button class="btn_legends" id="legendsPopup">
                          <span class="blue transferred"></span>
                          <span class="red complete"></span>
                          <span class="green in-progress"></span>
                          <span class="yellow scheduled"></span>
                        </b-button>
                        <b-popover target="legendsPopup" triggers="hover focus" :placement="'left'" :offset="60">
                          <template slot="title">
                            <div class="header-title ace_sec" aria-label="Legend">Legend</div>
                          </template>
                          <div class="row">
                            <div class="col-12 progress-section">
                              <div class="status_row ace_sec" aria-label="not in plan"><span class="not-in-plan lg_blc"></span> not in plan</div>
                              <div class="status_row ace_sec" aria-label="credits needed"><span class="credits-needed lg_blc"></span> {{creditLabel.toLowerCase()}}s needed</div>
                              <!--<div class="status_row ace_sec" style="display:none;"><span class="in-plan lg_blc"></span> in the plan</div>-->
                              <div class="status_row ace_sec" aria-label="scheduled"><span class="scheduled lg_blc"></span> scheduled</div>
                              <div class="status_row ace_sec" aria-label="in-progress"><span class="in-progress lg_blc"></span> in progress</div>
                              <div class="status_row ace_sec" aria-label="complete"><span class="complete lg_blc"></span> completed</div>
                              <div class="status_row ace_sec" aria-label="transferred"><span class="transferred lg_blc"></span> transferred</div>
                            </div>
                          </div>
                        </b-popover>
                      </div>
                      <template v-if="careerGoal && isSkillTaggingEnabled">
                        <div class="more-link" v-if="isCreditCompletionSelected">
                          <b-link @click="isCreditCompletionSelected = false" aria-label="show skill completion">show skill completion</b-link>
                        </div>
                        <div class="more-link" v-else>
                          <b-link @click="isCreditCompletionSelected = true" :aria-label="'show ' + creditLabel.toLowerCase() + ' completion'">show {{creditLabel.toLowerCase()}} completion</b-link>
                        </div>
                      </template>
                      <template v-else>
                        <!--
                        <div class="more-link" v-if="planningStream !== undefined && planningStream.programGuides && planningStream.programGuides.length > 1">
                          <b-link @click="navigateToStream()" aria-label="Detailed Progress View"><span id="tourStep_1"></span>more</b-link>
                        </div>
                        -->
                        <div class="more-link" v-if="showViewPlanLink">
                          <b-link tabindex="0" @click="navigateToStreamTime()" aria-label="Detailed Plan View"><span id="tourStep_1"></span>view plan</b-link>
                        </div>
                        <div class="more-link" v-if="planningStream !== undefined && planningStream.programGuides && planningStream.programGuides.length > 1">
                          <b-link tabindex="0" @click="navigateToStreamCategory()" aria-label="Detailed Category View">more</b-link>
                        </div>
                      </template>
                      <template v-else="!careerGoal && !isSkillTaggingEnabled">
                        <div class="tour_step_placehoder">
                          <span id="tourStep_1"></span>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="right-tab-col row">
                    <div class="stream-content-section col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12">
                      <div class="summary_sec">
                        <div class="summary_sec_row ace_sec_txt" v-if="careerGoal" :title="careerGoal"><span class="label">Career Goal:</span> <span class="value">{{careerGoal}}</span></div>
                        <div class="summary_sec_row ace_sec_txt" v-if="major" :title="major"><span class="label" v-if="showMajorLabel">{{majorLabel}}: </span><span class="value">{{major}}</span></div>
                        <div class="summary_sec_row ace_sec_txt" v-if="advisorName" :title="advisorName"><span class="heading-label"><strong>Advisor:</strong></span> <span class="heading-label">{{advisorName}}</span></div>
                        <div class="summary_sec_row ace_sec_txt" v-if="yearOfCompletion" :title="yearOfCompletion"><span class="label">Year of Completion:</span> <span class="value">{{yearOfCompletion}}</span></div>
                        <div class="summary_sec_row ace_sec_txt" v-if="overallCreditsCompleted"><span class="value">{{overallCreditsCompleted}}</span> <span class="label">{{creditLabel.toLowerCase()}}s completed out of</span> <span class="value">{{overallTotalCredits}}</span></div>
                        <!--<div class="head-row center_row" v-if="majorGpa"><span class="heading-label">Major GPA<strong>:</strong> </span> <span class="data-desc" :title="majorGpa">{{majorGpa}}</span> </div> -->
                        <div class="head-row center_row ace_sec_txt" v-if="overallGpa"><span class="heading-label">Overall GPA<strong>:</strong> </span> <span class="data-desc" :title="overallGpa">{{overallGpa}} </span> </div>
                        <div class="result-row"></div>
                      </div>
                    </div>
                    <div class="course-completion-section col-xl-7 col-lg-7 col-md-7 col-sm-12 col-xs-12">
                      <div v-show="isCreditCompletionSelected">
                        <div class="pie-chart-section col-12" v-if="dashboardPlanning && dashboardPlanning.length > 0">
                          <div class="pie-chart">
                            <div class="pie_chart_container ace_sec_txt" id="overallCreditCompletionChart"></div>
                          </div>
                          <div class="pie-title ace_sec_txt" :aria-label="'Overall ' + creditLabel + ' Completion'">Overall {{creditLabel}} Completion</div>
                        </div>
                        <div class="pie-chart-section col-12" v-else>
                          <div class="pie-title">
                            <dummy-graph ref="DummyGraph"></dummy-graph>
                          </div>
                        </div>
                        <div class="space-bar-section col-7"></div>
                      </div>
                      <div v-show="!isCreditCompletionSelected">
                        <template v-for="(careerProgress, key, i) in planningStream.careerProgressMap" v-if="planningStream && planningStream.careerProgressMap">
                          <div class="pie-chart-section row" v-if="careerProgress && careerProgress.progressByTypeMap && careerProgress.progressByTypeMap.TOTAL">
                            <template v-if="(i === 0)">
                              <div class="col-xl-9 col-lg-8 col-md-8 col-sm-9 col-xs-9 stu_db_grph">
                                <div class="pie-chart">
                                  <div class="pie_chart_container ace_sec_txt" id="overallSkillCompletionChart"></div>
                                </div>
                                <div class="pie-title ace_sec_txt" aria-label="Overall Skill Completion">{{competencyTagSourceLabelMap[key]}}: Overall Skill Completion</div>
                              </div>
                              <div class="col-xl-3 col-lg-4 col-md-4 col-sm-3 col-xs-3 stu_db_lg">
                                <div class="status_row lg_row ace_sec_txt" aria-label="Completed"><span class="lg_blc gc_completed"></span> Completed</div>
                                <div class="status_row lg_row ace_sec_txt" aria-label="In Progress"><span class="lg_blc gc_in_progress"></span> In Progress</div>
                                <div class="status_row lg_row ace_sec_txt" aria-label="In the Plan"><span class="lg_blc gc_in_plan"></span> In the Plan</div>
                                <div class="status_row lg_row ace_sec_txt" aria-label="Missing"><span class="lg_blc gc_missing"></span>  Missing</div>
                              </div>
                            </template>
                          </div>
                          <div class="pie-chart-section col-12" v-else>
                            <div class="pie-title">
                              <dummy-graph ref="DummyGraph"></dummy-graph>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <div class="pie-chart-section col-12">
                            <div class="pie-title">
                              <dummy-graph ref="DummyGraph"></dummy-graph>
                            </div>
                          </div>
                        </template>
                      </div>
                      <template v-if="careerGoal && isSkillTaggingEnabled">
                        <div class="more-link more-link-bottom" v-if="planningStream !== undefined && planningStream.programGuides && planningStream.programGuides.length > 1">
                          <b-link @click="navigateToStream()" aria-label="Detailed Progress View"><span id="tourStep_1"></span>more</b-link>
                        </div>
                        <div class="more-link more-link-bottom" v-if="showViewPlanLink">
                          <b-link @click="navigateToStreamTime()" aria-label="Detailed Plan View"><span id="tourStep_1"></span>view plan</b-link>
                        </div>
                      </template>
                      <template v-else="!careerGoal && !isSkillTaggingEnabled">
                        <div class="tour_step_placehoder">
                          <span id="tourStep_1"></span>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="notificationPopupContainer" class="notification-popup-container"></div>
          </div>
          <div class="dashboard-row notifications-panel col-xl-3 col-lg-12 col-md-12 col-sm-12">
            <div class="">
              <div class="card ace_sec" aria-label="Urgent Notifications Section">
                <div class="card-header">
                  <span class="icon icon-bell"></span>
                  <span class="label" role="heading">Notifications</span>
                </div>
                <div class="card-body notification-content-section">
                  <div class="msg_row_section msg_row_section_urgent">
                    <div class="msg_section_inner msg_section_inner_urgent">
                      <template v-for="(message, index) in recommendationsAndNotifications">
                        <b-popover :target="'un_' + key + '-' + index"  triggers="click" :ref="'notificationPopover_' + key + '-' + index" container="notificationPopupContainer">
                          <div class="header-title">
                            <span class="icon icon-user"></span>
                            <span class="user-name">{{message.name}}</span>
                            <button class="btn_close" aria-label="close" @click="closeNotificationPopup(key + '-' + index)">
                              <span class="ic-close"></span>
                            </button>
                          </div>
                          <div class="content-body">
                            <div class="notifications-row">
                              <div class="message-creator-avatar"><span class="icon-user"></span></div>
                              <div class="msg-section">
                                <div class="user-row">
                                  <span class="user-name-section">{{message.name}}</span>
                                  <span class="time-section">{{message.date}}</span>
                                </div>
                                <template v-if="message.isFile">
                                  <div class="msg-row">
                                    <a :href="message.text" target="_blank" style="color: #0645AD;">{{message.fileName}}</a>
                                  </div>
                                </template>
                                <template v-else>
                                  <div class="msg-row" v-html="message.text"></div>
                                </template>
                              </div>
                            </div>
                          </div>
                        </b-popover>
                        <div class="notifications-row ace_sec_txt" :id="'un_' + key + '-' + index" v-if="message.type === 'Urgent Notification'">
                          <div class="message-creator-avatar"><span class="icon-user"></span></div>
                          <div class="msg-section">
                            <div class="user-row">
                              <span class="user-name-section">{{message.name}}</span>
                              <span class="time-section">{{message.date}}</span>
                            </div>
                            <template v-if="message.isFile">
                              <div class="msg-row">
                                <a :href="message.text" target="_blank" style="color: #0645AD;">{{message.fileName}}</a>
                              </div>
                            </template>
                            <template v-else>
                              <div class="msg-row" v-html="message.text"></div>
                            </template>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-section row">
          <div class="dashboard-row enrolled-course-section col-xl-5 col-lg-6 col-md-12 col-sm-12">
            <div class="card ace_sec" aria-label="Current Courses Section">
              <div class="card-header">
                <span class="icon icon-course"></span>
                <span class="label" role="heading" aria-level="3">Current Courses</span>
                <span id="tourStep_2"></span>
              </div>
              <div class="card-body tab-panel">
                <div class="tab-section">
                  <b-tabs>
                    <b-tab title="Past">
                      <div class="item">
                        <div class="course">
                          <div class="master_course_name" >EDU 201</div>
                          <div class="thumbnail_container">
                            <div class="icon-course"></div>
                          </div>
                        </div>
                        <div class="course">
                          <div class="master_course_name" >ITL 510</div>
                          <div class="thumbnail_container">
                            <div class="icon-course"></div>
                          </div>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab title="Current" active>
                      <div class="card-body carousel slide">
                        <div class="carousel-inner">
                          <button tabindex="0" class="button-primary fa fa-angle-left float-left" v-if="courses.length > 0" :disabled="page < 1" @click="prev" aria-label="previous course"></button>
                          <template v-if="courses.length === 0">
                            <div class="msg_no_data ace_sec_txt" aria-label="No enrolled courses">No enrolled courses</div>
                          </template>
                          <div class="item course_list active" tabindex="-1">
                            <template v-for="course in courses">
                              <button tabindex="0" class="row course ace_sec" :aria-label="'course ' + course.title" @click="navigateToCourseDashboard(course.uuid)" :title="course.title" role="button">
                                <div class="col-12 title_new">
                                  <v-clamp class="title_txt" autoresize :max-lines="3">{{ course.title }}</v-clamp>
                                </div>
                                <div class="col-12 thumbnail_container">
                                  <span class="icon-course">
                                    <span class="icon-master" v-if="course.master">m</span>
                                  </span>
                                </div>
                              </button>
                            </template>
                          </div>
                          <button tabindex="0" class="button-primary fa fa-angle-right float-right" v-if="courses.length > 0"  :disabled="lastPage === true" @click="next" aria-label="next course"></button>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab title="Future">
                      <div class="item">
                        <div class="course">
                          <div class="master_course_name" >EDU 201</div>
                          <div class="thumbnail_container">
                            <div class="icon-course"></div>
                          </div>
                        </div>
                        <div class="course">
                          <div class="master_course_name" >ITL 510</div>
                          <div class="thumbnail_container">
                            <div class="icon-course"></div>
                          </div>
                        </div>
                      </div>
                    </b-tab>
                  </b-tabs>
                </div>
              </div>
            </div>
          </div>
          <div id="recommendationPopupContainer" class="recommendation-popup-container"></div>
          <div class="dashboard-row recommendations-section col-xl-4 col-lg-6 col-md-12 col-sm-12">
            <div class="card ace_sec" aria-label="Recommendations Section">
              <div class="card-header">
                <span class="icon icon-bullhorn"></span>
                <span class="label" role="heading" aria-level="4">Recommendations</span>
              </div>
              <div class="card-body tab-panel">
                <div class="tab-section">
                  <b-tabs>
                    <div class="msg_row_section msg_row_section_recommendation">
                      <div class="msg_section_inner msg_section_inner_recommendation">
                        <template v-for="(message, index) in recommendationsAndNotifications" v-if="message.type === 'Recommendation'">
                          <div class="notifications-row ace_sec_txt" :id="'r_' + key + '-' + index">
                            <div class="message-creator-avatar"><span class="icon-user"></span></div>
                            <div class="msg-section">
                              <div class="user-row">
                                <span class="user-name-section">{{message.name}}</span>
                                <span class="time-section"> {{message.date}}</span>
                              </div>
                              <template v-if="message.isFile">
                                <div class="msg-row">
                                  <a :href="message.text" target="_blank" style="color: #0645AD;">{{message.fileName}}</a>
                                </div>
                              </template>
                              <template v-else>
                                <div class="msg-row" v-html="message.text"></div>
                              </template>
                            </div>
                          </div>
                          <b-popover :target="'r_' + key + '-' + index"  triggers="click" :ref="'recommendationPopover_' + key + '-' + index" container="recommendationPopupContainer">
                            <div class="header-title">
                              <span class="icon icon-admin"></span>
                              <span class="user-name">{{message.name}}</span>
                              <button class="btn_close" @click="closeRecommendationPopup(key + '-' + index)">
                                <span class="ic-close"></span>
                              </button>
                            </div>
                            <div class="content-body">
                              <div class="notifications-row">
                                <div class="message-creator-avatar"><span class="icon-admin"></span></div>
                                <div class="msg-section">
                                  <div class="user-row">
                                    <span class="user-name-section">{{message.name}}</span>
                                    <span class="time-section">{{message.date}}</span>
                                  </div>
                                  <template v-if="message.isFile">
                                    <div class="msg-row">
                                      <a :href="message.text" target="_blank" style="color: #0645AD;">{{message.fileName}}</a>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <div class="msg-row" v-html="message.text"></div>
                                  </template>
                                </div>
                              </div>
                            </div>
                          </b-popover>
                        </template>
                      </div>
                    </div>
                    <!--
                    <b-tab title="Academic" active  aria-label="Academic recommendations">

                    </b-tab>
                    <b-tab v-if="shouldAlertForRecommendations" @click="setCocurricularTabClicked" title="Co-curricular" aria-label="Co-curricular recommendations">
                      <template v-if="recommendations.length > 0" v-for="recommendation in recommendations">
                        <div class="notifications-row ace_sec_txt">
                          <div class="msg-section" @click="navigateToEntityPage(recommendation.pageName, recommendation.uuid)">
                            <div class="msg-row">
                              {{ recommendation.title }}
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div class="msg_no_data ace_sec_txt" aria-label="No new Recommendations">No new Recommendations</div>
                      </template>
                    </b-tab>
                    <b-tab v-else-if="!shouldAlertForRecommendations" title="Co-curricular" aria-label="Co-curricular recommendations">
                      <template v-if="recommendations.length > 0" v-for="recommendation in recommendations">
                        <div class="notifications-row ace_sec_txt">
                          <div class="msg-section" @click="navigateToEntityPage(recommendation.pageName, recommendation.uuid)">
                            <div class="msg-row">
                              {{ recommendation.title }}
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div class="msg_no_data ace_sec_txt" aria-label="No new Recommendations">No new Recommendations</div>
                      </template>
                    </b-tab>
                    <b-tab title="People" aria-label="People recommendations">
                      <div class="msg_no_data ace_sec_txt" aria-label="Coming Soon">Coming Soon</div>
                      <!--
                        <div class="notifications-row">
                          <div class="message-creator-avatar"><span class="icon-admin"></span></div>
                          <div class="msg-section">
                            <div class="user-row">
                              <span class="user-name-section">Prof. Kandinsky</span>
                              <span class="time-section">6:18 PM</span>
                            </div>
                            <div class="msg-row">
                              You have to get my signature for registering in CS400
                            </div>
                          </div>
                        </div>

                        <div class="notifications-row">
                          <div class="message-creator-avatar"><span class="icon-user"></span></div>
                          <div class="msg-section">
                            <div class="user-row">
                              <span class="user-name-section">Prof. Zinn</span>
                              <span class="time-section">6:18 PM</span>
                            </div>
                            <div class="msg-row">
                              You have to clear your dues to get the credits
                            </div>
                          </div>
                        </div>

                    </b-tab>
                    -->
                  </b-tabs>
                </div>
              </div>
            </div>
          </div>
          <div class="dashboard-row quick-links  col-xl-3 col-lg-12 col-md-12 col-sm-12">
            <div class="card ace_sec" aria-label="Quick Links Section">
              <div class="card-header">
                <span class="icon icon-link"></span>
                <span class="label" role="heading" aria-level="5">Quick Links</span>
                <span id="tourStep_3"></span>
              </div>
              <div class="card-body quick-links-section">
                <div class="card-content v_scroll">
                  <div class="quick_link">
                    <ul role="list">
                      <li v-for="quickLink in quickLinks">
                        <a :href="quickLink.url" target="_blank" :aria-label="'Link to ' + quickLink.title" class="ace_sec_txt" role="link" :title="quickLink.title">{{quickLink.title}}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- profile Modal Component -->
      <b-modal ref="loadingProfileModal" centered hide-footer class="profile-new-popup" no-close-on-backdrop>
        <div slot="modal-header">
          <div class="checkbox-header">
            <input type="checkbox" v-model="isDoNotOpenProfilePopup" aria-labelledby="notShowAgain">
            <label class="label-info" id="notShowAgain">Don't show me this again</label>
          </div>
          <div class="icon icon-mentor"></div>
          <b-btn
            size="sm"
            class="btn_close"
            variant="primary"
            @click="hideProfilePopup"
            aria-lable="close profile popup">
            <span class="ic-close"></span>
          </b-btn>
        </div>
        <div class="content-section">
          <div class="left-col">
            <div class="thumbnail-row">
              <div class="default-thumbnail">
                <img :src="personProfile.thumbnailURI" v-if="profileLoaded && personProfile.thumbnailURI" class="profile-img">
                <div class="icon-mentor" v-else></div>
                <!--
                  <div class="process">10% Complete</div>
                  -->
              </div>
            </div>
          </div>
          <div class="right-col">
            <div class="field-section">
              <div class="field-row">
                <div class="field-title" id="majorValue">Major</div>
                <div class="field-form">
                  <input type="text" class="input-search" aria-labelledby="majorValue" :value="major" disabled>
                </div>
              </div>
            </div>
            <div class="field-section">
              <div class="field-row">
                <div class="field-title" id="minorValue">Minor</div>
                <div class="field-form">
                  <input type="text" class="input-search" aria-labelledby="minorValue" :value="minor" disabled>
                </div>
              </div>
            </div>
            <div class="field-section">
              <div class="field-row">
                <div class="field-title" id="concentrationValue">Concentration</div>
                <div class="field-form">
                  <input type="text" class="input-search" aria-labelledby="concentrationValue" :value="concentration" disabled>
                </div>
              </div>
            </div>
            <div class="field-section">
              <div class="field-row">
                <div class="field-title" id="careerValue">Career Goal</div>
                <div class="field-form">
                  <autocomplete
                    ref="autocomplete"
                    :source="careerSearchEndPoint"
                    :placeholder="careerGoalPlaceholder"
                    input-class="form-control"
                    results-property="careers"
                    :results-display="formattedDisplay"
                    :request-headers="authHeaders"
                    @selected="afterCareerSelected">
                  </autocomplete>
                </div>
              </div>
            </div>
          </div>
          <div class="footer-row">
            <div class="info-row" tabindex="0">We gathered some profile information from SIS. The more information you provide us the better we can help you explore programs and career interests Complete your profile now and then start exploring. </div>
            <div class="right-cols">
              <button class="btn" aria-label="complete profile" @click="saveProfile">complete profile</button>
            </div>
          </div>
          <div class="footer-row footer-explore" v-if="isExplorePackageEnabled">
            <div class="info-row">Complete profile later. Start exploring programs and career interests now!</div>
            <div class="right-cols">
              <button class="btn" aria-label="explore" @click="navigateToExplore"><i class="icon-explore"></i> start exploring now</button>
              <div class="dashboard-link">
                <a href="javascript:void(0);" @click="hideProfilePopup">No Thanks, Go to Dashboard</a>
              </div>
            </div>
          </div>
        </div>
      </b-modal>

    </div>
  </div>
</template>

<script>
  import '../../../assets/module/css/dashboard/tfaDashboard.min.css'
  import { mapState, mapActions } from 'vuex'
  import * as d3 from 'd3'
  import DummyGraph from './dummyGraph'
  import Autocomplete from 'vuejs-auto-complete'
  import { PACKAGE } from '../../../package_constants'
  import { db } from '../../../firebase'
  import VClamp from 'vue-clamp'

  var staticQuickLinks = function () {
    var quickLinks = []
    return quickLinks
  }

  export default {
    name: 'student-dashboard',
    components: {
      DummyGraph,
      Autocomplete,
      VClamp
    },
    props: ['forceShowProfile', 'forceShowTour'],
    data: () => {
      return {
        uObj: JSON.parse(localStorage.getItem('userobj')),
        page: 0,
        courses: [],
        showComponent :false,
        career: '',
        isDoNotOpenProfilePopup: false,
        isDoNotOpenGuide: false,
        lastPage: false,
        quickLinks: [],
        currentChannel: 'Pragya',
        messages: [],
        recommendationsAndNotifications: [],
        careerIdeas: [],
        completedQuests: 0,
        continueQuestAction: {},
        cocurricularTabClicked: false,
        personProfile: {},
        profileLoaded: false,
        isCreditCompletionSelected: true,
        skillProgressLabelMap: {
          'completed': 'Completed',
          'inProgress': 'In Progress',
          'planned': 'In the Plan',
          'missing': 'Missing'
        },
        competencyTagSourceLabelMap: {
          'EMSI': 'EMSI',
          'COS': 'Career One Stop',
          'BGT': 'Burning Glass Technologies',
          'MIT': 'MIT',
          'NACE': 'NACE'
        },
        careerSearchEndPoint: window.location.origin + '/career/search?query=',
        steps: [
          /*
          {
            target: '#tourStep_0',
            content: 'Click here to explore programs and careers.',
            params: {
              placement: 'right'
            }
          },
          {
            target: '#tourStep_1',
            content: 'Click on "more" see a detailed breakdown of your ' + this.creditLabel + 'completion.',
            params: {
              placement: 'left'
            }
          },*/
          {
            target: '#tourStep_2',
            content: 'Click on a course below to start learning.',
            params: {
              highlight: false,
              placement: 'top'
            }
          },
          /*
          {
            target: '#tourStep_3',
            content: 'Have any questions? Use the tutorial to learn more about the dashboard.',
            params: {
              placement: 'top'
            }
          }*/
        ],
        tourOptions: {
          useKeyboardNavigation: true,
          labels: {
            buttonSkip: 'skip tour',
            buttonPrevious: '<< prev',
            buttonNext: 'next >> ',
            buttonStop: 'finish tour'
          },
          startTimeout: 1000
        }
      }
    },
    mounted () {
      this.loadStudentDashboard()
    },
    beforeUpdate () {
      this.disableTabIndex()
    },
    created () {
      
      this.$watch('planningStream', (planningStream) => {
        if (planningStream) {
          this.currentChannel = planningStream.uuid
          this.$bindAsArray('messages', db.ref('channels/' + this.currentChannel + '/Messages'))
        }
      }, {
        immediate: true
      })
    },
    firebase: {
      messages: {
        source: db.ref('channels/' + this.currentChannel + '/Messages'),
        readyCallback: function () {
        },
        cancelCallback: function (e) {
          console.log('Could not get messages', e)
        }
      }
    },
    watch: {
      messages () {
        setTimeout(() => {
          var msgSectionHeight = $('.msg_section_inner_recommendation').innerHeight()
          $('.msg_row_section_recommendation').scrollTop(msgSectionHeight)
          var msgSectionHeight2 = $('.msg_section_inner_urgent').innerHeight()
          $('.msg_row_section_urgent').scrollTop(msgSectionHeight2)
        }, 100)
      },
      isDoNotOpenProfilePopup (newIsDoNotOpenProfilePopup) {
        this.loadSaveProfilePopup({isDoNotOpenProfilePopup: newIsDoNotOpenProfilePopup})
      },
      isDoNotOpenGuide (newIsDoNotOpenGuide) {
        this.loadSaveProfileTour({isDoNotOpenGuide: newIsDoNotOpenGuide})
      },
      career (newCareer) {
        this.loadSaveProfileCareer({careerGoal: newCareer})
      }
    },

    methods: {
      ...mapActions([
        'loadQuickLinks',
        'loadEnrolledCourses',
        'loadPlanningStream',
        'loadUserAdvisor',
        'loadUserCareerGoal',
        'loadUserPreferences',
        'loadJobRecommendations',
        'loadLogDashboardActivity',
        'loadSaveProfilePopup',
        'loadSaveProfileTour',
        'loadSaveProfileCareer',
        'loadInstitutionPackage',
        'loadPersonProfile',
        'loadInstitutionDetail',
        'loadRecommendationsAndNotificationsFromAllChannels'
      ]),
      async populateRecommendationsAndNotifications () {
        this.recommendationsAndNotifications = await this.loadRecommendationsAndNotificationsFromAllChannels()
      },
      formattedDisplay (result) {
        return result.name
      },
      afterCareerSelected (item) {
        let career = item.selectedObject
        this.career = career.name
        this.$refs.autocomplete.clear()
      },
      showProfilePopup () {
        this.$refs.loadingProfileModal.show()
        $('.ace_sec').attr('tabindex', -1)
        $('.ace_sec_hd').attr('tabindex', -1)
        $('.ace_sec_txt').attr('tabindex', -1)
        $('.profile-new-popup').attr('tabindex', 1)
      },
      disableTabIndex () {
        // let section = $('.nav-link')
        // $(section).removeAttr('tabindex')
      },
      hideProfilePopup () {
        this.loadLogDashboardActivity({action: 'closeProfilePopup', page: 'dashboard', link: ''})
        this.$refs.loadingProfileModal.hide()
      },
      closeNotificationPopup (index) {
        this.$refs['notificationPopover_' + index][0].$emit('close')
      },
      closeRecommendationPopup (index) {
        this.$refs['recommendationPopover_' + index][0].$emit('close')
      },
      loadStudentDashboard () {
        const institutionId = this.institution.uuid || localStorage.getItem('institutionId')
        this.loadInstitutionDetail(institutionId).then(res => { 
                 if(res.learnerDashboard && (res.learnerDashboard.indexOf('modern')!=-1)){
                        return this.$router.push({name: 'modernDashboard'})
                 }
              });

        this.loadInstitutionPackage({uuid: institutionId, isAggregated: false}).then(res => {
          if (this.isLearnerDashboardEnabled) {
            return this.$router.push({name: 'learnerDashboard'})
          }
          this.populateRecommendationsAndNotifications()
          if (this.isClearlyNextPackageEnabled) {
            if (this.showAccountSubscription) {
              return this.$router.push({ name: 'clearlyNextStudentSubscription', params: { uuid: this.uObj.uuid } })
            } else {
              return this.$router.push({ name: 'clearlyNextStudentDashboard' })
            }
          }
          if (!this.isStudentDashboardEnabled) {
            return this.$router.push({ name: 'studentDashboardExplore' })
          }
          this.showComponent = true
          this.populateEnrolledCourses()
          this.loadUserPreferences().then(res => {
            this.isDoNotOpenProfilePopup = res.doNotOpenProfilePopup
            this.isDoNotOpenGuide = res.doNotOpenGuide
            if (this.isProfilePopupEnabled) {
              if (!this.isDoNotOpenProfilePopup || this.forceShowProfile) {
                this.showProfilePopup()
              }
            }
            if (this.isTourEnabled) {
              if (!this.isDoNotOpenGuide || this.forceShowTour) {
                this.showTour()
              }
            }
          })
        })
        this.loadPlanningStream().then(res => {
          if (this.dashboardPlanning && this.dashboardPlanning.length > 0) {
            let colorScale = {
              'transferred': '#56b5e8',
              'completed': '#508102',
              'in progress': '#9fc958',
              'scheduled': '#f5b318',
              'credits needed': '#cf7908',
              'not in plan': '#969696',
              'in the plan': '#1eb1eb'
            }
            setTimeout(() => {
              this.generatePieChart(this.dashboardPlanning[0].progress.values, colorScale, 'overallCreditCompletionChart')
            }, 250)
          }

          if (this.planningStream && this.planningStream.careerProgressMap) {
            let sources = Object.keys(this.planningStream.careerProgressMap)
            if (sources != null && sources.length > 0) {
              sources.forEach((source, i) => {
                let careerProgress = this.planningStream.careerProgressMap[source]
                if ((i === 0) && careerProgress.progressByTypeMap) {
                  let total = careerProgress.progressByTypeMap.TOTAL
                  if (total) {
                    let keys = Object.keys(total)
                    let data = []
                    keys.forEach(key => {
                      let value = total[key]
                      let label = this.skillProgressLabelMap[key]
                      if (label && value > 0) {
                        data.push({label: label, value: value})
                      }
                    })
                    let colorScale = {
                      'Completed': '#508102',
                      'In Progress': '#9fc958',
                      'In the Plan': '#f5b318',
                      'Missing': '#cf7908'
                    }
                    this.generatePieChart(data, colorScale, 'overallSkillCompletionChart')
                  }
                }
              })
            }
          }
        })
        this.loadUserAdvisor(localStorage.getItem('userid'))
        this.loadQuickLinks().then(res => {
          const quickLinks = (this.links.length > 0) ? this.links : staticQuickLinks()
          $.each(quickLinks, (index, quickLink) => {
            this.quickLinks.push(quickLink)
          })
        })
        
        this.loadJobRecommendations()
        this.loadLogDashboardActivity({action: 'viewDashboard', page: 'dashboard', link: ''})
        this.loadUserCareerGoal().then(res => {
          this.career = res
        })
        this.loadPersonProfile(this.uObj.uuid).then(res => {
          this.personProfile = res
          this.profileLoaded = true
        })
        window.addEventListener('resize', this.handleWindowResize)
      },

      showTour () {
        this.$tours['myTour'].start()
      },

      getLabel (label) {
        if (label.indexOf('credits') !== -1) {
          return label.replace('credit', this.creditLabel.toLowerCase())
        }
        return label
      },

      generatePieChart (data, colorScale, elementId) {
        var pieChartContainerHeight = 162
        var pieChartInnerRadius = 35
        var width = pieChartContainerHeight
        var height = pieChartContainerHeight
        var radius = pieChartContainerHeight / 2

        var tooltip = d3.select('body')
                      .append('div')
                      .style('position', 'absolute')
                      .style('z-index', '10')
                      .style('visibility', 'hidden')
                      .style('color', '#111')
                      .attr('class', 'report-tooltip-xaxis')
                      .style('padding', '8px')
                      .style('border-radius', '6px')
                      .style('font', 'bold 15px Arial')
                      .text('tooltip')

        var canvas = d3.select('#' + elementId).append('svg')
                     .data([data]).attr('width', width).attr('height', height).append('g')
                     .attr('transform', 'translate(' + radius + ',' + radius + ')')

        var arc = d3.arc()
                  .outerRadius(radius)
                  .innerRadius(pieChartInnerRadius)

        var pie = d3.pie()
                  .value(function (d) { return d.value }).sort(null)

        var arcs = canvas.selectAll('.arc')
                   .data(pie(data))
                   .enter().append('g')
                   .attr('class', 'arc')

        arcs.append('path')
            .attr('d', arc)
            .style('fill', (d, i) => { return colorScale[d.data.label] })
            .on('mouseover', (d) => {
              tooltip.text(this.getLabel(d.data.label) + ': ' + d.data.value + (''))
              tooltip.style('visibility', 'visible')
            })
            .on('mousemove', function () {
              return tooltip.style('top', (d3.event.pageY - 25) + 'px').style('left', (($(window).width() - 150) > d3.event.pageX ? (d3.event.pageX + 10) : (d3.event.pageX - 130)) + 'px')
            })
            .on('mouseout', function () {
              return tooltip.style('visibility', 'hidden')
            })

        arcs.append('text')
            .attr('transform', (d) => { return 'translate(' + arc.centroid(d) + ')' })
            .style('font', 'bold 12px Arial')
            .style('fill', '#fff')
            .style('cursor', 'default')
            .attr('text-anchor', 'middle')
            .text((d) => { return d.data.value })
            .on('mouseover', (d) => {
              tooltip.text(this.getLabel(d.data.label) + ': ' + d.data.value + (''))
              tooltip.style('visibility', 'visible')
            })
            .on('mousemove', () => {
              return tooltip.style('top', (d3.event.pageY - 25) + 'px').style('left', (($(window).width() - 150) > d3.event.pageX ? (d3.event.pageX + 10) : (d3.event.pageX - 130)) + 'px')
            })
            .on('mouseout', () => {
              return tooltip.style('visibility', 'hidden')
            })
      },

      handleWindowResize (event) {
        let routeName = this.$router.currentRoute.name
        if (routeName === 'studentDashboard') {
          this.populateEnrolledCourses()
        }
      },

      populateEnrolledCourses () {
        var windowWidth = $(window).width()
        let itemCount = 2
        if (windowWidth < 1570) {
          itemCount = (windowWidth < 1326) ? 1 : 2
        }
        const pagingOptions = {page: this.page, count: itemCount}
        this.loadEnrolledCourses(pagingOptions).then(res => {
          if (res && res.length > 0) {
            this.courses = res
            if (res.length < this.count) {
              this.lastPage = true
            }
          } else {
            if (this.page > 0) {
              this.page -= 1
            }
            this.lastPage = true
          }
        })
      },

      beforeDestroy: function () {
        window.removeEventListener('resize', this.handleWindowResize)
      },

      prev () {
        if (this.page > 0) {
          this.page -= 1
          this.populateEnrolledCourses()
        }

        if (this.lastPage) {
          this.lastPage = false
        }
      },

      next () {
        if (!this.lastPage) {
          this.page += 1
          this.populateEnrolledCourses()
        }
      },

      navigateToCourseDashboard (uuid) {
        this.$store.commit('LOAD_COURSE', {})
        this.$store.commit('LOAD_CLASS_SUMMARY', {})
        this.$store.commit('LOAD_COURSE_TOPICS', {})
        this.$store.commit('LOAD_COURSE_LINEAR_TOPICS', {})
        this.loadLogDashboardActivity({action: 'clickEnrolledCourse', page: 'dashboard', link: ''})
        return this.$router.push({name: 'courseDashboard', params: { uuid: uuid }})
      },
      navigateToEntityPage (pageName, entityId) {
        this.$router.push({ name: pageName, params: { uuid: entityId } })
      },
      navigateToStream () {
        this.loadLogDashboardActivity({action: 'clickMore', page: 'dashboard', link: 'more'})
        if (this.isCreditCompletionSelected) {
            return this.$router.push({ name: 'streamProgress', params: { uuid: this.planningStream.uuid } })
        } else {
          return this.$router.push({ name: 'streamCareer', params: { uuid: this.planningStream.uuid } })
        }
      },
      navigateToExplore () {
        this.loadLogDashboardActivity({action: 'clickExplore', page: 'dashboard', link: 'explore'})
        return this.$router.push({name: 'exploreIntro', params: {reload: true}})
      },
      navigateToPersonProfile () {
        if (this.personProfile) {
          this.loadLogDashboardActivity({action: 'clickPersonProfile', page: 'dashboard', link: 'explore'})
          return this.$router.push({name: 'personDetail', params: {uuid: this.personProfile.uuid, loadDataFromServer: true}})
        }
      },
      navigateToStreamTime () {
        this.loadLogDashboardActivity({action: 'clickMore', page: 'dashboard', link: 'more'})
        if (this.isTimeViewEnabled) {
          return this.$router.push({ name: 'streamTime', params: { uuid: this.planningStream.uuid } })
        } else {
          return this.$router.push({ name: 'streamPlanner', params: { uuid: this.planningStream.uuid } })
        }
      },
      navigateToStreamCategory () {
        this.loadLogDashboardActivity({action: 'clickMore', page: 'dashboard', link: 'more'})
        if (this.navigateMoreToCategoryView)
          return this.$router.push({ name: 'streamCategory', params: { uuid: this.planningStream.uuid } })
        else
          return this.$router.push({ name: 'streamProgress', params: { uuid: this.planningStream.uuid } })
      },
      saveProfile () {
        this.loadLogDashboardActivity({action: 'saveProfilePopup', page: 'dashboard', link: ''})
        this.loadSaveProfileCareer({careerGoal: this.career})
        this.loadSaveProfilePopup({isDoNotOpenProfilePopup: this.isDoNotOpenProfilePopup})
        this.loadSaveProfileTour({isDoNotOpenGuide: this.isDoNotOpenGuide})
        this.navigateToPersonProfile()
        this.$refs.loadingProfileModal.hide()
      },
      setCocurricularTabClicked () {
        this.cocurricularTabClicked = true
      }
    },

    computed: {
      ...mapState({
        'links': state => state.dashboard.quickLinks,
        'planningStream': state => state.dashboard.planningStream,
        'dashboardPlanning': state => state.dashboard.dashboardPlanning,
        'advisor': state => state.user.advisor,
        'jobRecommendations': state => state.dashboard.jobRecommendations,
        'careerGoal': state => state.user.careerGoal,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'institution': state => state.institution.institution
      }),
      creditLabel () {
        let creditLabelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CUSTOM_CREDIT_LABEL_FEATURE_ID]
        if (!creditLabelFeature || !creditLabelFeature.enabled || !creditLabelFeature.label) {
          return 'Credit'
        }
        return creditLabelFeature.label
      },
      authHeaders () {
        return {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      },
      careerGoalPlaceholder () {
        return (this.careerGoal || 'Type In To Search Careers')
      },
      username () {
        return localStorage.getItem('userFullName')
      },
      yearOfCompletion () {
        if (this.showYearOfCompletion) {
          if (this.uObj && this.uObj.yearOfCompletion) {
            return this.uObj.yearOfCompletion
          }
        }
        return ''
      },
      major () {
        if (this.uObj && this.uObj.major1Title) {
          return this.uObj.major1Title
        }
        return ''
      },
      minor () {
        if (this.uObj && this.uObj.minor1Title) {
          return this.uObj.minor1Title
        }
        return ''
      },
      concentration () {
        if (this.uObj && this.uObj.concentration1Title) {
          return this.uObj.concentration1Title
        }
        return ''
      },
      majorGpa () {
        if (this.uObj && this.uObj.majorGpa) {
          return this.uObj.majorGpa
        }
        return ''
      },
      overallGpa () {
        if (this.uObj && this.uObj.overallGpa) {
          return this.uObj.overallGpa
        }
        return ''
      },
      overallCreditsCompleted () {
        if (this.planningStream.programGuides && this.planningStream.programGuides.length > 1 && this.planningStream.programGuides[0].progress) {
          return this.planningStream.programGuides[0].progress.completed + this.planningStream.programGuides[0].progress.transfered
        }
        return ''
      },
      overallTotalCredits () {
        if (this.planningStream.programGuides && this.planningStream.programGuides.length > 1 && this.planningStream.programGuides[0].progress) {
          return this.planningStream.programGuides[0].progress.total
        }
        return ''
      },
      advisorName () {
        if (this.advisor) {
          return this.advisor.name
        } else {
          return null
        }
      },
      recommendations () {
        let formattedRecommendations = []
        let jobRecommendations = this.jobRecommendations
        if (jobRecommendations) {
          jobRecommendations.forEach((job) => {
            job['pageName'] = 'jobHome'
            formattedRecommendations.push(job)
          })
          return formattedRecommendations
        } else {
          return []
        }
      },
      isProfilePopupEnabled () {
        let profilePopupFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROFILE_FEATURE_ID]
        if (profilePopupFeature) {
          return profilePopupFeature.enabled
        }
        return false
      },
      isTourEnabled () {
        let tourFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.TOUR_FEATURE_ID]
        if (tourFeature) {
          return tourFeature.enabled
        }
        return false
      },
      isClearlyNextPackageEnabled () {
        let clearlyNextFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CLEARLY_NEXT_FEATURE_ID]
        if (clearlyNextFeature && clearlyNextFeature.enabled) {
          return true
        }
        return false
      },
      isLearnerDashboardEnabled () {
        let learnerDashboardFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_LEARNER_DASHBOARD_FEATURE_ID]
        if (learnerDashboardFeature) {
          return learnerDashboardFeature.enabled
        }
        return false
      },
      isStudentDashboardEnabled () {
        let studentDashboardFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.STUDENT_DASHBOARD_FEATURE_ID]
        if (studentDashboardFeature && !studentDashboardFeature.enabled) {
          return false
        }
        return true
      },
      showAccountSubscription () {
        let clearlyNextFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CLEARLY_NEXT_FEATURE_ID]
        if (clearlyNextFeature) {
          let flags = clearlyNextFeature.flags
          for (var i = 0; i < flags.length; i++) {
            let flag = flags[i]
            if (flag.title === 'showAccountSubscription') {
              return flag.enabled
            }
          }
        }
        return false
      },
      showYearOfCompletion () {
        let studentProgressFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.STUDENT_PROGRESS_FEATURE_ID]
        if (studentProgressFeature) {
          let flags = studentProgressFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showYearOfCompletion') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      showMajorLabel () {
        let studentProgressFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.STUDENT_PROGRESS_FEATURE_ID]
        if (studentProgressFeature) {
          let flags = studentProgressFeature.flags
          for (var i = 0; i < flags.length; i++) {
            let flag = flags[i]
            if (flag.title === 'showMajorLabel') {
              return flag.enabled
            }
          }
        }
        return false
      },
      navigateMoreToCategoryView () {
        let studentProgressFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.STUDENT_PROGRESS_FEATURE_ID]
        if (studentProgressFeature) {
          let flags = studentProgressFeature.flags
          for (var i = 0; i < flags.length; i++) {
            let flag = flags[i]
            if (flag.title === 'navigateMoreToCategoryView') {
              return flag.enabled
            }
          }
        }
        return false
      },
      majorLabel () {
        let studentProgressFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.STUDENT_PROGRESS_FEATURE_ID]
        if (studentProgressFeature) {
          let flags = studentProgressFeature.flags
          for (var i = 0; i < flags.length; i++) {
            let flag = flags[i]
            if (flag.title === 'showMajorLabel' && $.trim(flag.label).length > 0) {
              return flag.label
            }
          }
        }
        return 'Major'
      },
      isExplorePackageEnabled () {
        let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_FEATURE_ID]
        if (exploreFeature && exploreFeature.enabled) {
          return true
        }
        return false
      },
      isTimeViewEnabled () {
        let timeViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.TIME_VIEW_FEATURE_ID]
        if (timeViewFeature && timeViewFeature.enabled) {
          return true
        }
        return false
      },
      showViewPlanLink () {
        if (this.planningStream) {
          if (this.planningStream.programGuides && this.planningStream.programGuides.length > 1) {
            return false
          } else {
            return true
          }
        }
      },
      shouldAlertForRecommendations () {
        let recommendations = this.recommendations
        if (!recommendations || !recommendations.length || recommendations.length <= 0) {
          return false
        }
        return recommendations.length > 0 && !this.cocurricularTabClicked
      },
      isSkillTaggingEnabled () {
        let skillTaggingFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SKILL_TAGGING_FEATURE_ID]
        if (skillTaggingFeature) {
          return skillTaggingFeature.enabled
        }
        return false
      }
    }
  }
</script>
<style scoped>
  .next {
    margin-top: 10%;
  }
  .icon-master {
    float: right !important;
    margin-top: 0px !important;
    margin-left: 0px !important;
  }
  .legend-title {
    padding-left: 15px;
    font-size: 19px;
    font-family: robotoSlab_Light;
    margin-bottom: 17px;
  }
  .icon-progress {
    font-size: 40px;
    margin: 0 14px 0 15px;
  }
  .legend-section {
    height: 46px;
    display: flex;
    align-items: center;
    float:right;
  }
  .profile-img{
    height: 120px;
    width: 120px;
  }
  .footer-row {
    padding-bottom: 30px!important;
  }
  #overallSkillCompletionChart {
    width: 100%;
    float: left;
    text-align: center;
  }
  .more-link-bottom {
    float: right;
    width: 15% !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/tfaStudentDashboard.vue